import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';
import { hoverAttrs } from '../hoverCard';

/** Аватар из «плоских» данных /api/sublace/overview (без модели User). */
export default class MiniAvatar extends Component {
  view() {
    const {
      user,
      size = 32,
      link = true,
      withName = false
    } = this.attrs;
    if (!user) return null;
    const name = user.displayName || user.username;
    const letter = (name || '?').charAt(0).toUpperCase();
    const style = {
      width: size + 'px',
      height: size + 'px',
      '--size': size + 'px'
    };
    const avatar = user.avatarUrl ? m("img", {
      className: "SlAvatar",
      src: user.avatarUrl,
      alt: "",
      loading: "lazy",
      style: style
    }) : m("span", {
      className: "SlAvatar SlAvatar--letter",
      style: {
        ...style,
        '--avatar-color': user.color || hashColor(name)
      },
      "aria-hidden": "true"
    }, letter);
    const content = withName ? [avatar, m("span", {
      className: "SlAvatar-name",
      style: user.color ? {
        color: user.color
      } : undefined
    }, name)] : avatar;
    if (!link) return m("span", {
      className: "SlAvatarWrap",
      title: name
    }, content);
    return m(Link, Object.assign({
      className: "SlAvatarWrap",
      href: app.route('user', {
        username: user.slug || user.username
      }),
      "aria-label": name
    }, hoverAttrs(user)), content);
  }
}
function hashColor(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) hash = hash * 31 + str.charCodeAt(i) | 0;
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 45%, 42%)`;
}
flarum.reg.add('sublace-forum', 'forum/components/MiniAvatar', MiniAvatar);